import eventAward2023 from '@/assets/event-award-2023.png';
import eventAward2024 from '@/assets/event-award-2024.png';
import eventAward2025 from '@/assets/event-award-2025.png';
import eventAward2026 from '@/assets/event-award-2026.png';

const awards = [
  { src: eventAward2023, alt: 'Event Award 2023 — Meilleure Agence Artistique' },
  { src: eventAward2024, alt: 'Event Award 2024 — Meilleur Spectacle Revue et Animation Artistique' },
  { src: eventAward2025, alt: 'Event Award 2025 — Meilleur Spectacle Revue et Animation Artistique' },
  { src: eventAward2026, alt: "Event Award 2026 — Meilleure Agence Événementielle de l'Aube" },
];

interface Props {
  align?: 'left' | 'center';
  className?: string;
}

const FounderAwards = ({ align = 'left', className = '' }: Props) => (
  <div className={`mt-6 ${className}`}>
    <p className={`text-[10px] font-heading font-semibold uppercase tracking-[0.15em] text-primary mb-3 ${align === 'center' ? 'text-center' : ''}`}>
      Lauréat Event Awards 2023 → 2026
    </p>
    <a
      href="https://www.evenementielpourtous.com/cygnature-production-126315"
      target="_blank"
      rel="noopener noreferrer"
      className={`flex items-center gap-3 md:gap-5 flex-wrap ${align === 'center' ? 'justify-center' : ''} hover:opacity-90 transition-opacity`}
      aria-label="Voir les distinctions Event Awards de Cygnature Production"
    >
      {awards.map((award) => (
        <img
          key={award.alt}
          src={award.src}
          alt={award.alt}
          className="w-12 md:w-16 h-auto object-contain"
          loading="lazy"
        />
      ))}
    </a>
  </div>
);

export default FounderAwards;
